// extracted by mini-css-extract-plugin
export default {"telecom-btn":"button_telecom-btn__FiHGi","telecom-btn-true":"button_telecom-btn-true__bwWx1","telecom-btn-false":"button_telecom-btn-false__2TOkn"};